import { type ReactNode, type RefObject, createContext, useContext } from 'react';

const GanttScrollContext = createContext<RefObject<HTMLDivElement | null> | null>(null);

interface ProviderProps {
  scrollRef: RefObject<HTMLDivElement | null>;
  children: ReactNode;
}

export function GanttScrollProvider({ scrollRef, children }: ProviderProps) {
  return <GanttScrollContext.Provider value={scrollRef}>{children}</GanttScrollContext.Provider>;
}

/** Get the ref to the single horizontally-scrolling Gantt container. */
export function useGanttScrollRef(): RefObject<HTMLDivElement | null> | null {
  return useContext(GanttScrollContext);
}
